<template>
  <div class="row">
    <div class="col-12 midia-app-label-sm">
      <span class="">{{ title }}</span>
    </div>
    <div
      class="col-12 midia-app-label-lg"
      :style="
        wrap
          ? `white-space: pre-wrap; color: var(--${descriptionColor})`
          : `color: var(--${descriptionColor})`
      "
    >
      {{ description }}
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    default: "",
  },

  description: {
    type: String,
    default: "",
  },

  wrap: {
    type: Boolean,
    default: false,
  },

  descriptionColor: {
    type: String,
    default: "globalBlack000000",
  },
});
</script>
